import React, { memo } from 'react'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import PropTypes from 'prop-types'
import Link from 'core/components/Link'
import Typography from 'core/components/Typography/index'
import { HelperTextWrapper } from './style'

function TextHelper({ children, handleCLick, setMarginTop }) {
  return (
    <HelperTextWrapper setMarginTop={setMarginTop}>
      <Typography color="primary" variant="caption" fontWeight="regular" paragraph={false}>
        <Link onClick={handleCLick}>
          <InfoOutlinedIcon fontSize="small" />
          {children}
        </Link>
      </Typography>
    </HelperTextWrapper>
  )
}

TextHelper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  handleCLick: PropTypes.func.isRequired,
}

TextHelper.defaultProps = {
  children: '',
}

export default memo(TextHelper)
